<template>
  <div class="my-navbar">
    <transition name="fade">
      <div class="aalign-center my-navbar__logos">
        <img
          src="/img/logos/alfathbelajarlogo.svg"
          alt=""
        />
      </div>
    </transition>

    <div class="my-navbar__right sm-hide">
      <a class="mr-2" :href="'https://alfathbelajar.com/subject' + (section.subject_id ? ('/'+section.subject_id) : '')">
        <my-button>
          <fa-icon icon="long-arrow-alt-left" class="mr-1"></fa-icon>
          Course Detail
        </my-button>
      </a>

      <!-- <my-button class="mr-2" v-show="true || isLoggedIn">
        <fa-icon :icon="['far', 'star']" class="mr-1"></fa-icon>
        Beri Rating
      </my-button> -->

      <my-button
        class="mr-2"
        type="fill-blue"
        v-if="true || isLoggedIn"
        @click="goToForum"
      >
        Forum
        <fa-icon icon="comment-dots" class="ml-1"></fa-icon>
      </my-button>

      <b-dropdown text="Notification" class="my-dropdown mr-2">
        <template #button-content>
          <fa-icon icon="bell" class="mr-1"></fa-icon>  
          <b-badge variant="danger" v-if="unread">{{unread}}</b-badge>
        </template>
        <b-dropdown-item @click="goToNotif()" class="text-center">
          <a href="#">See All Notification</a>
        </b-dropdown-item>
        <b-dropdown-item v-for="(itm, idx) in notifs" @click="goToForumDetail(itm)" :key="'a-'+idx">
          <div class="aspace-between mb-2">
            <img src="/img/avatars/user-avatar4.png" alt="avatar" width="30"/>
            <span class="discussion__time">
              <b>{{ itm.user_name }}</b>
            </span>
            <span class="discussion__time">
              {{ $helpers.formatDateTimeID(itm.created_at) }}
            </span>
          </div>
          <div v-if="itm.type=='forum_reply'">
            <a href="#">{{ itm.user_name }}</a> 
            menjawab pertanyaan forum 
            <a href="#">{{ itm.target_name }}</a> 
          </div>
          <div v-else>
            {{ itm.user_name }} {{ itm.type }}
          </div>
        </b-dropdown-item>
      </b-dropdown>
      <a href="https://alfathbelajar.com/dashboard/editprofile">
        <my-button style="padding: 0 11px 0 15px;">
          <fa-icon icon="user-cog" class="mr-1"></fa-icon>
        </my-button>
      </a>
    </div>

    <div class="my-navbar__right sm-show">
      <a class="mr-2" :href="'https://alfathbelajar.com/subject' + (section.subject_id ? ('/'+section.subject_id) : '')">
        <my-button style="padding: 0 11px 0 15px;">
          <fa-icon icon="home" class="mr-1"></fa-icon>
        </my-button>
      </a>
      <my-button class="mr-2" type="fill-blue" v-if="isLoggedIn" @click="goToForum" style="padding: 0 11px 0 15px;">
        <fa-icon icon="comment-dots" class="mr-1"></fa-icon>
      </my-button>
      <b-dropdown text="Notification" class="my-dropdown mr-2">
        <template #button-content>
          <fa-icon icon="bell" class="mr-1"></fa-icon> 
          <b-badge variant="danger" v-if="unread">{{unread}}</b-badge>
        </template>
        <b-dropdown-item @click="goToNotif()" class="text-center">
          <a href="#">See All Notification</a>
        </b-dropdown-item>
        <b-dropdown-item v-for="(itm, idx) in notifs" @click="goToForumDetail(itm)" :key="'b-'+idx">
          <div class="aspace-between mb-2">
            <img src="/img/avatars/user-avatar4.png" alt="avatar" width="30"/>
            <span class="discussion__time">
              <b>{{ itm.user_name }}</b>
            </span>
            <span class="discussion__time">
              {{ $helpers.formatDateTimeID(itm.created_at) }}
            </span>
          </div>
          <div v-if="itm.type=='forum_reply'">
            <a href="#">{{ itm.user_name }}</a> 
            menjawab pertanyaan forum 
            <a href="#">{{ itm.target_name }}</a> 
          </div>
          <div v-else>
            {{ itm.user_name }} {{ itm.type }}
          </div>
        </b-dropdown-item>
      </b-dropdown>
      <a href="https://alfathbelajar.com/dashboard/editprofile">
        <my-button style="padding: 0 11px 0 15px;">
          <fa-icon icon="user-cog" class="mr-1"></fa-icon>
        </my-button>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../store/types";
import { DB } from '@/helpers/fireinit';

export default {
  props: {},
  data() {
    return {
      notifs: [], 
      unread: 0,
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN, 
      user: types.USER,
      section: types.SECTION
    })
  },
  mounted() {
    var that = this
    var d = new Date()
    DB.ref('notif-user/'+this.user.id).off()
    DB.ref('notif-user/'+this.user.id).orderByChild("created_at").startAt(d.toISOString()).on("child_added", function(snapshot) {
      var newNotif = snapshot.val();
      if(that.$route.name == 'notif') {
        that.updateNotif(1)
      }
      that.unread++
      that.getNotifList()
      that.$bvToast.toast('Ada jawaban baru di forum ' + newNotif.target_name, {
        title: 'Jawaban Baru',
        autoHideDelay: 3000, 
        toaster: 'b-toaster-top-right',
        variant: 'success'
      })
    });
    this.getNotifList()
    this.getUnred()
  },
  methods: {
    ...mapActions({
      notifList: types.NOTIF_LIST,
      notifUnread: types.NOTIF_UNREAD, 
      updateNotif: types.UPDATE_NOTIF,
      logout: types.LOGOUT
    }),
    getNotifList() {
      var payload = {
        params: { 
          limit: 10, 
          offset: 0
        }
      }
      this.notifList(payload)
      .then((response) => {
        this.notifs = response
      })
      .catch((error) => {

      });
    },
    getUnred() {
      this.notifUnread()
      .then((response) => {
        this.unread = response[0].count
      })
      .catch((error) => {

      });
    },
    goLogout() {
      this.logout();
    }, 
    goToForum() {
      this.$router.push('/forum')
    },
    goToForumDetail(item) {
      this.$router.push('/forum/'+item.target_id)
    },
    goToNotif() {
      this.$router.push('/notif')
    }
  }
};
</script>
